import {FC} from 'react'

import cn from 'classnames/bind'

import IconCheck from 'src/assets/icons/checkSuccess.svg'

import s from './PaymentFeatures.module.scss'

const cx = cn.bind(s)
const data = [
	'30 Day Refund',
	'Cancel Anytime',
	'Located in The United States',
	'No Additional Charges',
]

interface IPaymentFeaturesProps {
	className?: string
}

const PaymentFeatures: FC<IPaymentFeaturesProps> = ({className}) => (
	<ul className={cx(className, 'wrapper')}>
		{data.map((item) => (
			<li key={item} className={cx('item')}>
				<IconCheck className={cx('icon')} />
				{item}
			</li>
		))}
	</ul>
)

export default PaymentFeatures
